import { useCallback, useRef } from "react";

export function useDebounce(delay: number) {
  const timeout = useRef<ReturnType<typeof setTimeout> | undefined>(undefined);
  return useCallback(
    function (callback: { (): void }) {
      clearTimeout(timeout.current);
      timeout.current = setTimeout(callback, delay);
    },
    [delay],
  );
}
